<template>
  <div class="page-container">
    <div class="material-container">
      <div class="container-header">
        <h2>素材库-素材规格</h2>
      </div>
      <div class="container-main">
        <el-button
          class="new-format-button"
          size="mini"
          type="primary"
          @click="newFormat"
        >
          新建规格
        </el-button>
        <app-filter
          :filter-list="table_filter"
          @search="searchTable"
        />
      </div>
    </div>
    <div class="material-main">
      <app-table
        ref="my-table"
        :table-key="table_key"
        :tablep="material_format_list_params"
        :table-props="table_props"
        :table-list-data="format_data"
      />

      <format-form
        v-if="format_form.is_show"
        title="新建规格"
        width="500px"
        :is-show="format_form.is_show"
        :dialog-form="format_form.form_params"
        :edit-data="format_form.edit_data"
        :form-data-api="form_data"
        @cancel="formatFormCancel"
        @confirm="formatFormConfirm"
      />
    </div>
  </div>
</template>

<script>
// 素材规格列表接口
import MaterialFormatResource from '@/api/material/format';
const materialFormatResource = new MaterialFormatResource();

export default {
  components: {
    'material-preview': () => import('../components/material-preview'),
    'format-form': () => import('./components/format-form'),
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  data() {
    return {
      someAttr: 'hidden',
      // 素材规格列表参数
      material_format_list_params: {
        page: 1,
        limit: 10,
      },
      // 表格属性
      table_props: {
        height: '448px',
      },
      // 筛选条件
      table_filter: require('./module/table-filter.js')(this),
      // 表格头部
      table_key: require('./module/table-key.js')(this),
      // 规格表单
      format_form: {
        is_show: false,
        edit_data: {},
        form_params: require('./module/form-params.js')(this),
      },
      format_data: {
        list: [],
        page_info: {
          total_number: 0,
          page: 1,
          page_size: 10,
          total_page: 4,
        },
      },
      form_data: null,
      is_mime: false,

    };
  },
  mounted() {
    this.getMaterialFormatList(this.material_format_list_params);
  },
  methods: {
    // 获取素材规格列表
    getMaterialFormatList: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .getMaterialFormatListApi(params)
          .then((response) => {
            this.format_data.list = response.list;
            this.format_data.page_info.total_number = this.format_data.list.length;
            this.$refs['my-table'].seekTable();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 创建素材规格
    createMaterialFormat: function(params) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .createMaterialFormatApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 更新素材规格
    updateMaterialFormat: function(params, id) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .updateMaterialFormatApi(params, id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 更新素材规格
    removeMaterialFormat: function(id) {
      return new Promise((resolve, reject) => {
        materialFormatResource
          .removeMaterialFormatApi(id)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 新建规格
    newFormat: function() {
      this.format_form.edit_data = {};
      this.form_data = this.createMaterialFormat;
      this.format_form.is_show = true;
    },
    // 编辑规格
    editFormat: function(row) {
      this.format_form.edit_data = row;
      this.form_data = this.updateMaterialFormat;
      this.format_form.is_show = true;
    },
    // 规格表单取消
    formatFormCancel: function() {
      this.format_form.is_show = false;
      for (const key in this.format_form.form_params) {
        const item = this.format_form.form_params[key];
        if (!item.hidden) {
          item.value = null;
        }
      }
      this.format_form.form_params.mime_type.options = [];
    },
    // 规格表单确定
    formatFormConfirm: function(data) {
      this.format_form.is_show = false;
      this.format_form.form_params.mime_type.options = [];
      this.getMaterialFormatList(this.material_format_list_params);
    },
    // 搜索表格
    searchTable: function(obj) {
      this.material_format_list_params = Object.assign(this.material_format_list_params, obj);

      this.getMaterialFormatList(this.material_format_list_params);
    },
  },
};
</script>

<style lang="scss" scoped>
$background_color: #eef0f3;
$padding: 20px;

.material-container {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  .container-header {
    border-bottom: 1px solid #fff;
    height: 40px;
    padding: 10px $padding;
    background-color: $background_color;
    h2 {
      margin: 0;
    }
  }
  .container-main {
    margin-top: 10px;
    padding: $padding;
    background-color: $background_color;
    .new-format-button {
      margin-right: 20px;
    }
  }
}
.material-main {
  padding: $padding;
  background-color: $background_color;
  margin-top: 20px;
  .preview-material {
    position: absolute;
    left: -100px;

  }
}
</style>
